import { useQuery } from '@hooks/reactQuery';

import { getDashboardRentGeneralSummary } from '@api/dashboardPO';

import { extractQueryParams } from '@utils/common';

import { IDashboardRentGeneralDTO } from '@interfaces/platform/dto/platformDashboardDTO';

import { refetchOptions } from '@constants/common';
import { DASHBOARD_RENT_GENERAL_SUMMARY } from '@constants/queryKeys';

const useQueryDashboardRentGeneralSummary = (params: IDashboardRentGeneralDTO) => {
	const { fromText, toText } = params;

	const {
		data: dashboardRentGeneralSummary,
		isLoading: isLoadingDashboardRentGeneralSummary,
		isFetching: isFetchingDashboardRentGeneralSummary,
	} = useQuery({
		queryKey: [DASHBOARD_RENT_GENERAL_SUMMARY, params],
		queryFn: extractQueryParams(getDashboardRentGeneralSummary),
		enabled: [!!fromText, !!toText],
		...refetchOptions,
	});

	return {
		dashboardRentGeneralSummary,
		isLoadingDashboardRentGeneralSummary: (isLoadingDashboardRentGeneralSummary && !!dashboardRentGeneralSummary)
			|| isFetchingDashboardRentGeneralSummary,
	};
};

export default useQueryDashboardRentGeneralSummary;

